var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{staticClass:"cus-table fs-14",attrs:{"bordered":"","data-source":_vm.dataSource,"columns":_vm.columns,"pagination":false,"rowKey":"status"}}),_c('coursework-user-dialog',{ref:"courseworkUserDialog"}),_c('print-ticket-dialog',{ref:"printTicketDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }